/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPNATUREOFINCOME = {
    Salary: 'S',
    Pension: 'P',
    Business: 'B',
    Dividends: 'D',
    Other: 'O',
    Profits: 'PF',
    Interest: 'I'
} as const;
export type IAPNATUREOFINCOME = typeof IAPNATUREOFINCOME[keyof typeof IAPNATUREOFINCOME];


export function IAPNATUREOFINCOMEFromJSON(json: any): IAPNATUREOFINCOME {
    return IAPNATUREOFINCOMEFromJSONTyped(json, false);
}

export function IAPNATUREOFINCOMEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPNATUREOFINCOME {
    return json as IAPNATUREOFINCOME;
}

export function IAPNATUREOFINCOMEToJSON(value?: IAPNATUREOFINCOME | null): any {
    return value as any;
}

